import { CLOUD_DOMAIN } from "shared/constants";
import { getTenantFromHostname } from "shared/utils";

import SamsaraAPIKeyGuide from "pages/SuperAdmin/Connections/ConnectionDetail/SamsaraAPIKeyGuide";

import { CredentialFieldDefinition, SettingFieldDefinition } from "./types";
import { getInboxAddressError } from "./validation";

// What each connector asks for, and with that which connectors can be set up here at all: the picker offers only the
// connectors listed in one of these tables, and the connection card renders whatever its connector lists. A new
// connector is a new row rather than a new page.
export const CONNECTOR_CREDENTIAL_FIELDS: Record<
  string,
  CredentialFieldDefinition[]
> = {
  samsara: [
    {
      name: "token",
      labelKey: "superadmin:connections.detail.api_key",
      placeholderKey: "superadmin:connections.detail.api_key_placeholder",
      helpDialog: SamsaraAPIKeyGuide,
    },
  ],
};

// A connector whose name doesn't read well in the generic "New <connector> connection" title.
export const CONNECTOR_NEW_TITLE_KEYS: Record<string, string> = {
  email_inbox: "superadmin:connections.detail.new_title_email_inbox",
};

export const CONNECTOR_SETTING_FIELDS: Record<
  string,
  SettingFieldDefinition[]
> = {
  email_inbox: [
    {
      name: "address",
      labelKey: "common:email_address",
      placeholderKey: "superadmin:connections.detail.email_address_placeholder",
      // Tenant UI hosts are <tenant>.<domain>, and the inbox domain mirrors the tenant's.
      suffix: `@${getTenantFromHostname()}.${CLOUD_DOMAIN}`,
      validate: getInboxAddressError,
    },
  ],
};
